import * as FaIcones from 'react-icons/fa';

export function Icone({ nome, tamanho, cor, desabilitado = false }) {
  const Icone = FaIcones[nome];

  return (
    <Icone
      style={{ width: tamanho, height: tamanho, zIndex: 2, opacity: desabilitado ? 0.7 : 1 }}
      color={cor}
    />
  );
}
